/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-backblow',['require','jquery','activities/scenario-activity','activities/activity-openairway'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  //var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var ActivityOpenAirway = require('activities/activity-openairway');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityBackBlow = ActivityOpenAirway.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    doneBtn: null,
    minPressCount: 1,
    correctPressCount: 0,
    totalBlows: 0,
    disableAfterReachingLimit: false,
    bvmMC: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ActivityOpenAirway.prototype.initialize.apply(this, arguments);
    },

    onBeforeDestroy: function()
    {
      if (this.doneBtn)
      {
        this.doneBtn.off('click');
        this.doneBtn.addClass('disabled');
      }

      ActivityOpenAirway.prototype.onBeforeDestroy.apply(this);
    },

    setupHandPositioning: function()
    {
      this.setupPlaceHands();
    },

    allComplete: function()
    {
      return true;
    },

    setupCompressions: function()
    {
      this.handMC = this.currentScene.find('[data-mc=handsHolder] [data-mc=hand]');
      //console.log('setup compressions', this.handMC);
      // setup the body and bvm states TODO

      this.playAudio('audio', this.currentPhase);
      this.currentPhase.hideCounter = (this.currentPhase.hideCounter !== undefined && (this.currentPhase.hideCounter === true || this.currentPhase.hideCounter.toLowerCase() === 'true'));
      this.currentPhase.hidePace = (this.currentPhase.hidePace !== undefined && (this.currentPhase.hidePace === true || this.currentPhase.hidePace.toLowerCase() === 'true'));

      this.counterPanel = this.currentScene.find('[data-mc=counterHolder]');
      this.showTime();

      if (this.counterPanel.length > 0)
      {
        this.counterPanel.find('[data-mc=text_tf]').show();
        this.counterPanel.find('[data-mc=disabled_mc]').hide();
        this.counterPanel.find('[data-mc=message]').show();
        if (this.currentPhase.hideCounter === true)
        {
          //console.log('hide counter', this.currentPhase.hideCounter, typeof(this.currentPhase.hideCounter), this.currentPhase);
          this.counterPanel.find('[data-mc=text_tf]').hide();
          this.counterPanel.find('[data-mc=disabled_mc]').show();
        }
        if (this.currentPhase.hidePace)
          this.counterPanel.find('[data-mc=message]').hide();

        if (this.currentPhase.hideCounter && this.currentPhase.hidePace)
        {
          this.counterPanel.hide();//visible = false;
        }
      }

      this.attempt = 0;

      this.handMC.on('touchstart mousedown', $.proxy(this.onMouseDownHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );
      this.handMC.on('touchend mouseup', $.proxy(this.onMouseUpHandler, this));//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      this.doneBtn = this.get('[data-mc=doneHolder] [data-mc=done]');
      this.doneBtn.addClass('disabled');
    },

    onMouseDownHandler: function($e)
    {
      $e.preventDefault();
      $e.stopImmediatePropagation();
      this.startAction();
      return false;
    },

    onMouseUpHandler: function($e)
    {
      $e.preventDefault();
      $e.stopImmediatePropagation();
      this.stopAction();
      return false;
    },

    startAction: function()
    {
      this.handMC.removeClass('release').addClass('compress');
      if (this.currentPhase['interrupt'] && this.totalBlows >= this.currentPhase['interrupt']) // interrupt
      {
        this.finish();
        return;
      }
    },

    stopAction: function()
    {
      this.handMC.removeClass('compress').addClass('release');
      this.handMC.stop().animate({scale: 1}, {duration: 0.5});
      this.totalBlows++;

      this.showTime(this.totalBlows);
      //this.counterPanel.find('[data-mc=text_tf]').html(this.totalBlows);

      //this.mc.body.removeEventListener(Event.ENTER_FRAME, this.onEnterFrame);

      //if ((!this.disableAfterReachingLimit && this.doneBtn.hasClass('disabled')) || this.totalBlows >= 2)
      if ((!this.disableAfterReachingLimit || this.totalBreathsCount >= 2) && this.doneBtn.hasClass('disabled'))
      {
        this.doneBtn.removeClass('disabled');
        this.doneBtn.one('click', $.proxy(this.onDoneClick, this));
        if (this.disableAfterReachingLimit)
          this.disableBreathButton();
      }
    },

    onDoneClick: function()
    {
      this.doneBtn.addClass('disabled');
      this.doneBtn.off('click');
      this.handMC.off('touchstart mousedown');
      this.handMC.off('touchend mouseup');//.setup( { onMouseDown: this.onMouseDownHandler, onMouseUp: this.onMouseUpHandler } );

      this.evaluatePerformance();
    },

    evaluatePerformance: function()
    {
      if (this.totalBlows !== 5)
      {
        this.downgradePerformance();
        this.playAudio('audio-feedback-incorrect', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      else
      {
        this.playAudio('audio-feedback-correct', this.currentPhase, $.proxy(this.finalComplete, this));
      }
      //console.log('perf', this.performance);
    },

    finalComplete: function()
    {
      this.finish();
    },

    finish: function($performance)
    {
      ScenarioActivity.prototype.finish.apply(this, arguments);
    },

    showTime: function($sec)
    {
      $sec = ($sec === undefined) ? 0 : $sec;
      if (!this.counterPanel)
        return;

      this.counterPanel.find('[data-mc=text_tf]').html($sec.toString());
    }

  /*****************************************************************************************************************///}

  });

  return ActivityBackBlow;

});

